import React, { useEffect } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import AppLayout from "Layouts/AppLayout";
// import SignInPage from "Pages/Auth/SignInPage";
import { NavLinks } from "Constants/NavLinks";
import UserPage from "Pages/User/UserPage";
import CreateUpdateUser from "Pages/User/CreateUpdateUser";
import UserDetailPage from "Pages/User/UserDetailPage";
// import ContestPage from "Pages/Contest/ContestPage";
// import ContestDetailPage from "Pages/Contest/ContestDetailPage";
import RequestPage from "Pages/Requests/RequestPage";
import RequestDetailPage from "Pages/Requests/RequestDetailPage";
import HomePage from "Pages/WebsitePages/Pages/HomePage/HomePage";
import AboutPage from "Pages/WebsitePages/Pages/AboutPage/AboutPage";
import InvestorWeek from "Pages/WebsitePages/Pages/InvestorWeek/InvestorWeek";
import InvestorAward from "Pages/WebsitePages/Pages/InvestorAward/InvestorAward";
import ParticipationsPage from "Pages/WebsitePages/Pages/Participants/ParticipationsPage";
import ParticipationDetailPage from "Pages/WebsitePages/Pages/Participants/ParticipationDetailPage";
import FeedbacksPage from "Pages/WebsitePages/Pages/Feedbacks/FeedbacksPage";
import Season4 from "Pages/WebsitePages/Pages/Season4/Season4";
import CertificateNamesPage from "Pages/CertificateNames/CertificateNamesPage";
import VerifyNamePage from "Pages/CertificateNames/VerifyNamePage";
import VerificationHistoryPage from "Pages/CertificateNames/VerificationHistoryPage";
import PrintCertificatePage from "Pages/CertificateNames/PrintCertificatePage";
import { useLocation } from "react-router-dom";

const routeTitles = {
  "/admin/user": "Users",
  "/sign-in": "Sign in",
  "/admin/contact-request": "Requests",
  "/admin/cms/home-page": "Home",
  "/admin/cms/about-page": "About",
  "/admin/cms/investor-week-page": "Investor week",
  "/admin/cms/investor-award-page": "Investor award",
  "/admin/cms/season-4": "Season 4",
  "/admin/feedbacks": "Feedbacks",
  "/admin/participations": "Participations",
  "/admin/certificate-names": "Certificate Names",
  "/admin/verify-name": "Verify Name",
  "/admin/verification-history": "Verification History",
  "/admin/print-certificate": "Print Certificate",
};

function getPageTitle(pathname) {
  const matchedKey =
    Object.keys(routeTitles)
      .filter((key) => pathname.includes(key)) // all matching keys
      .sort((a, b) => b.length - a.length)[0] || null; // pick the longest (most specific)

  return matchedKey ? routeTitles[matchedKey] + " - Mulim | مُلم" : "Mulim | مُلم";
}

export default function App() {
  let { path } = useRouteMatch();
  const location = useLocation();

  useEffect(() => {
    document.title = getPageTitle(location.pathname);
  }, [location.pathname]);

  return (
    <AppLayout links={NavLinks}>
      <Switch>
        <Route
          exact
          path={`${path}`}
          render={() => {
            return (
              //   isFetchingUserData ?
              <Redirect to={`${path}/contact-request`} />
            );
          }}
        />
        <Route exact path={`${path}/user`} component={UserPage} />
        <Route
          exact
          path={`${path}/user/create`}
          component={CreateUpdateUser}
        />
        <Route
          exact
          path={`${path}/user/edit/:userId`}
          component={CreateUpdateUser}
        />
        <Route
          exact
          path={`${path}/user/details/:userId`}
          component={UserDetailPage}
        />
        {/* <Route exact path={`${path}/contest`} component={ContestPage} />
            <Route exact path={`${path}/contest/details/:contestId`} component={ContestDetailPage} />
        */}
        <Route exact path={`${path}/contact-request`} component={RequestPage} />
        <Route
          exact
          path={`${path}/contact-request/details/:requestId`}
          component={RequestDetailPage}
        />
        <Route exact path={`${path}/cms/home-page`} component={HomePage} />
        <Route exact path={`${path}/cms/about-page`} component={AboutPage} />
        <Route
          exact
          path={`${path}/cms/investor-week-page`}
          component={InvestorWeek}
        />
        <Route
          exact
          path={`${path}/cms/investor-award-page`}
          component={InvestorAward}
        />
        <Route exact path={`${path}/cms/season-4`} component={Season4} />
        <Route
          exact
          path={`${path}/participations`}
          component={ParticipationsPage}
        />
        <Route exact path={`${path}/feedbacks`} component={FeedbacksPage} />
        <Route
          exact
          path={`${path}/participations/:participationId`}
          component={ParticipationDetailPage}
        />
        <Route
          exact
          path={`${path}/certificate-names`}
          component={CertificateNamesPage}
        />
        <Route exact path={`${path}/verify-name`} component={VerifyNamePage} />
        <Route
          exact
          path={`${path}/print-certificate`}
          component={PrintCertificatePage}
        />
        <Route
          exact
          path={`${path}/verification-history`}
          component={VerificationHistoryPage}
        />
      </Switch>
    </AppLayout>
  );
}
